import api from '@/lib/api';

/** Admin che ha messo una spunta (popolato dall'API). */
export interface ErrorLogActor {
  _id: string;
  profile?: { firstName?: string; lastName?: string };
}

export interface ErrorLogEntry {
  _id: string;
  source: string;
  code?: string;
  message: string;
  context?: Record<string, unknown>;
  createdAt: string;
  seenAt?: string | null;
  seenBy?: ErrorLogActor | null;
  handledAt?: string | null;
  handledBy?: ErrorLogActor | null;
}

export interface ErrorLogPage {
  items: ErrorLogEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export async function getErrorLogs(page: number, source?: string): Promise<ErrorLogPage> {
  const res = await api.get('/error-logs', { params: { page, limit: 50, source: source || undefined } });
  return res.data.data as ErrorLogPage;
}

/** Errori di oggi (giornata Europe/Rome) ancora da gestire — pallino in sidebar. */
export async function getTodayErrorCount(): Promise<{ count: number }> {
  const res = await api.get('/error-logs/today-count');
  return res.data.data as { count: number };
}

/** Spunta "visto" / "gestito" su una singola riga (super-admin). */
export async function setErrorLogStatus(
  id: string,
  flags: { seen?: boolean; handled?: boolean }
): Promise<ErrorLogEntry> {
  const res = await api.patch(`/error-logs/${id}/status`, flags);
  return res.data.data.item as ErrorLogEntry;
}
